import React from 'react';
import PropTypes from 'prop-types';

import { formatDate } from 'helpers/formatters/date_time_formats';
import { getRelativeDateLabel } from '../helpers';

export default function Reminder({ referenceDate, reminder }) {
  let label;
  if (reminder.sent) {
    label = formatDate(reminder.sentAt);
  } else {
    label = getRelativeDateLabel(reminder, referenceDate);
    if (!reminder.sendOn.static && label[0] === '0') {
      label = 'Same day';
    }
  }

  return <li>{label}</li>;
}

Reminder.propTypes = {
  referenceDate: PropTypes.string,
  reminder: PropTypes.shape({
    sent: PropTypes.bool,
    sentAt: PropTypes.string,
  }).isRequired,
};
